module.exports = __webpack_public_path__ + "static/img/gxk-default.57c458c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gxk-default.png
// module id = I0QO
// module chunks = 0